import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import useCategories from "../../../../utils/useCategories";
import CommonBankLogo from "../../../_utils/CommonBankLogo";
import ListContainer from "../../../_utils/CommonListView/ListContainer";
import ListDualText from "../../../_utils/CommonListView/ListSubComponent/ListDualText";
import ListTextWithIcon from "../../../_utils/CommonListView/ListSubComponent/ListTextWithIcon";
import TickerAnimation from "../../../_utils/TickerAnimation";
import ICONS from "../../../../assets/Icons";
import SVGComponent from "../../../_utils/SVGComponent";

const BeneficiaryTransactionListView = ({
  data,
  currentStatus,
  type,
  typepop,
  onClose,
  labelTransactions,
  isLabelClicked,
  filterRef,
  similarTxn,
  openTransHistory,
  handleLabelSelect,
  flowType,
  txnId,
}) => {
  const navigate = useNavigate();
  const categoryMapper = useCategories();
  const location = useLocation();
  const listdata = data || [];

  const services = useSelector((state) => state.refreshToken.services);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const getDistriStatusColor = (status) => {
    switch (status) {
      case "awaiting_verification":
      case "awaiting_funds":
      case "distribution_initiated":
      case "created":
      case "distribution_pending":
      case "approved":
        return "var(--queued)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "distribution_complete":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };
  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };
  return (
    <div className="standard-list-view-alignment">
      {listdata.map((item) => {
        const categoryIcon = categoryMapper(item?.category_id?.category_id);
        return (
          <ListContainer
            hoverHeight={GlobalConfiguration?.beneTxnListHoverHeight}
            key={item.id}
            isDisabled={
              flowType === "labelsSearch" ? item?.txn_id === txnId : false
            }
            filterRef={filterRef}
            context={item}
            onClickHandler={() => {
              const txnDetailsPath = `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${item.txn_id}`;
              if (type === "bene_account_detail_modal") {
                actionRestricted();
                return;
              }
              const options =
                item?.lifecycle_status === "pending" &&
                services?.includes("ABeneficiaryTxn")
                  ? {
                      state:
                        currentStatus === "require approval"
                          ? "require approval"
                          : item?.lifecycle_status,
                    }
                  : {};

              if (similarTxn === "similarTxn") {
                actionRestricted();
                return;
              }
              if (typepop === "transactionHistorypopup" && !isLabelClicked) {
                onClose();
                navigate(txnDetailsPath, {
                  state: {
                    isViewAll:
                      location.pathname ===
                      "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
                        ? true
                        : false,
                  },
                });
                window.location.reload();
                return;
              }
              if (isLabelClicked) {
                handleLabelSelect?.(item);
                return;
              }

              if (openTransHistory) {
                onClose();
              }
              navigate(txnDetailsPath, {
                replace: openTransHistory ? true : false,
                state: {
                  isViewAll:
                    location.pathname ===
                    "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
                      ? true
                      : false,
                  options: options,
                },
              });
            }}
            isSelected={
              Array.isArray(labelTransactions) &&
              labelTransactions.some((tx) => tx?.id === item?.txn_id)
            }
          >
            <list-body>
              <div className="w-full flex justify-between pr-padding-sm py-padding-sm gap-x-gap-sm">
                <div className={`flex flex-col gap-y-gap-sm w-full`}>
                  <div className="w-full flex gap-x-gap-sm">
                    <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-tr-border-radius-md rounded-br-border-radius-md">
                      <div className="flex gap-x-gap-sm items-center">
                        <CommonBankLogo
                          variant="small"
                          ifsc={item.beneficiary_account_ifsc_code}
                        />
                        <div className="border-l h-[-webkit-fill-available] border-primary-bg"></div>
                        <div className="w-icon-sm h-icon-sm flex-shrink-0">
                          <SVGComponent
                            url={categoryIcon?.url}
                            color={categoryIcon?.colour}
                          />
                        </div>
                      </div>
                    </div>
                    <p className="overflow-hidden whitespace-nowrap overflow-ellipsis items-center text-settled text-font-xs flex-1 flex font-semibold ">
                      <span>
                        {"INR " +
                          Number(item.amount)?.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                      </span>
                    </p>

                    <div className="flex gap-x-gap-sm justify-end items-center">
                      {/* <p className="text-text-primary font-normal text-font-xs min-w-standard-account-min-width  text-right">
                        {item.created_on
                          ? formatDateViewAll(item.created_on, false, false)
                          : "Not given"}
                      </p> */}
                      <div
                        style={{
                          display:
                            item?.confidential_transaction === "Y"
                              ? "flex"
                              : "none",
                        }}
                        className="gap-x-gap-sm ml-margin-sm justify-end"
                      >
                        <img
                          className="w-icon-sm h-icon-sm"
                          src={ICONS?.CONFIDENTIAL_TRANSACTION}
                          alt=""
                        />
                      </div>
                      <img
                        style={{
                          display: isLabelClicked ? "flex" : "none",
                        }}
                        className="w-icon-sm h-icon-sm cursor-pointer"
                        src={
                          Array.isArray(labelTransactions) &&
                          labelTransactions?.some(
                            (tx) => tx?.id === item.txn_id,
                          )
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                        }
                        alt=""
                      />
                    </div>
                  </div>

                  <div className="w-full pl-padding-sm flex justify-between items-center">
                    <p className="text-font-xs flex-1 text-text-primary font-normal">
                      <TickerAnimation text={item?.beneficiary_account_name} />
                    </p>
                  </div>
                </div>
              </div>
            </list-body>
            <list-hover>
              <ListDualText
                text1={
                  currentStatus === "require approval"
                    ? "Require approval"
                    : item.lifecycle_status || "N/A"
                }
                text1Color={getStatusColor(item.lifecycle_status)}
                text1FontWeight="var(--font-semibold)"
                subtext1="Approval status"
                text2={
                  item.distribution_lifecycle_status === "created"
                    ? "Distribution created"
                    : item.distribution_lifecycle_status === "awaiting_funds"
                      ? "Awaiting funds"
                      : item.distribution_lifecycle_status ===
                          "distribution_initiated"
                        ? "Distribution initiated"
                        : item.distribution_lifecycle_status === "abandoned"
                          ? "Distribution abandoned"
                          : item.distribution_lifecycle_status === "rejected"
                            ? "Distribution rejected"
                            : item.distribution_lifecycle_status === "failed"
                              ? "Distribution failed"
                              : item.distribution_lifecycle_status ===
                                  "distribution_complete"
                                ? "Distribution complete"
                                : item.distribution_lifecycle_status ===
                                    "approved"
                                  ? "Distribution approved"
                                  : item.distribution_lifecycle_status || "N/A"
                }
                subtext2="Distribution status"
                text2Color={
                  item.distribution_lifecycle_status === "N/A"
                    ? "var(--text-primary)"
                    : getDistriStatusColor(item.distribution_lifecycle_status)
                }
                text2FontWeight="var(--font-semibold)"
                textCase="none"
              />

              <ListTextWithIcon
                type={"text"}
                text={
                  item?.labels?.length
                    ? item?.labels?.join(", ")
                    : "No labels assigned"
                }
                iconComponentArray={[
                  {
                    icon: ICONS?.LABEL,
                  },
                ]}
              />
            </list-hover>
          </ListContainer>
        );
      })}
    </div>
  );
};

export default BeneficiaryTransactionListView;
